import { ISettingValues } from '../../Settings/ISettings'

export const checkIfCustomDuration = (settings: ISettingValues) => {
  const isNewFmf = settings.onlineAppointmentsNewFreeMomentFinder
  const isCustomDuration = settings.fmfCustomCustomerDurations
  return isNewFmf && isCustomDuration
}
